exports.install = function (Vue, commonService) {
  if (this.installed) {
    return
  }

  this.installed = true

  Vue.commonService = commonService

  Object.defineProperty(Vue.prototype, '$commonService', {
    get: function get () { return commonService }
  })
}



// WEBPACK FOOTER //
// ./src/services/common-service/plugin.js